<ngx-loading-bar #loading color="#3AA36B" includeSpinner="false" height="3px"></ngx-loading-bar>

<div id="services-new">
  <app-new [title]="title" [subtitle]="subtitle" [urlBack]="urlBack">
    <div class="container" [formGroup]="newService">
      <div class="row">
        <div class="col">
          <label>
            <span>PRESTADOR DE SERVIÇO</span>

            <select formControlName="cdFornecedor">
              <option value="">Selecione o prestador de serviço</option>
              <option *ngFor="let provider of providersArr;" [value]="provider.cdFornecedor">{{ provider.nmRazaoSocial }}</option>
            </select>
          </label>
        </div>

        <div class="col">
          <label>
            <span>LOJA NOVA</span>

            <select formControlName="flNovaLoja">
              <option value="1">Sim</option>
              <option value="0">Não</option>
            </select>
          </label>
        </div>
      </div>

      <app-stores [selectedStores]="selectedStores" (stores)="storesValues($event);" [provider]="newService.controls.cdFornecedor.value"></app-stores>

      <div class="row">
        <div class="col">
          <label>
            <span>IMPOSTO SAP</span>
            <input type="text" (keypress)="limiteCaractere($event, 2)" formControlName="cdsImpostoSap">
          </label>
        </div>

        <div class="col">
          <label>
            <span>COMPLEMENTO SAP</span>
            <input type="text" (keypress)="limiteCaractere($event, 20)" formControlName="dsComplementoSap">
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>
            <span>OPERAÇÃO SAP</span>
            <input type="text" (keypress)="limiteCaractere($event, 4)" formControlName="dsOperacaoSap">
          </label>
        </div>

        <div class="col">
          <label>
            <span>PROJETO SAP</span>
            <input type="text" (keypress)="limiteCaractere($event, 24)" formControlName="dsProjetoSap">
          </label>
        </div>
      </div>


      <app-related-equipments [relatedEquipments]="relatedEquipments" (relateds)="equipmentsValues($event);"></app-related-equipments>

      <div class="row">
        <div class="col">
          <button (click)="addNewService();">CADASTRAR SERVIÇO</button>
        </div>
      </div>
    </div>
  </app-new>
</div>
